export type ThemeMode = "light" | "dark";

export const THEME_STORAGE_KEY = "theme-mode";

export const getStoredThemeMode = (): ThemeMode => {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const applyThemeMode = (mode: ThemeMode) => {
  document.documentElement.setAttribute("data-theme-mode", mode);
  document.documentElement.setAttribute("data-menu-styles", mode);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch { }
};

export const toggleThemeMode = (): ThemeMode => {
  const current =
    document.documentElement.getAttribute("data-theme-mode") === "dark"
      ? "dark"
      : "light";
  const next: ThemeMode = current === "dark" ? "light" : "dark";
  applyThemeMode(next);
  return next;
};
